import store from '../store'
const { useEffect, useState, useRef } = React;

const shallowEqual = (objA, objB) => {
    if (Object.is(objA, objB)) return true;

    if (
        typeof objA !== 'object' || objA === null ||
        typeof objB !== 'object' || objB === null
    ) {
        return false;
    }

    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;

    for (let key of keysA) {
        if (!Object.prototype.hasOwnProperty.call(objB, key)) return false;
        if (!Object.is(objA[key], objB[key])) return false;
    }

    return true;
}

export const useSelect = (selector) => {
    const [selectedState, setSelectedState] = useState(() => selector(store.getState()));
    const selectedStateRef = useRef(selectedState);

    useEffect(() => {
        const handleStateChange = () => {
            const newSelectedState = selector(store.getState());

            if (!shallowEqual(newSelectedState, selectedStateRef.current)) {
                selectedStateRef.current = newSelectedState;
                setSelectedState(newSelectedState);
            }
        };

        const unsubscribe = store.subscribe(handleStateChange);
        return () => unsubscribe();
    }, [selector]);

    return selectedState;
}
